import React from 'react'

import CollapsibleContent from '@/components/misc/CollapsibleContent'
import { ServiceFeeDetail } from '@/components/misc/ServiceFeesTable/ServiceFeesTableRows'
import { useIsPdf } from '@/hooks/useIsPdf'

interface Props {
  serviceFee: ServiceFeeDetail
}

const ServiceFeeNotes: React.FC<Props> = ({ serviceFee }) => {
  const { notes } = serviceFee
  const isPdf = useIsPdf()

  if (!notes) {
    return null
  }

  return isPdf ? (
    notes
  ) : (
    <CollapsibleContent content={notes} collapseThreshold={100} />
  )
}

export default ServiceFeeNotes
